$(document).ready(function () {
  $('[name="business"]').on('change', function() {
    const form = $(this).parents('form')

    if ($(this).val() === '1') {
      form.find('.business-only').show()
      form.find('.personal-only').hide()
      form.find('input.personal-only').attr('required', false)
      form.find('input.business-only[data-required="true"]').attr('required', true)
    } else {
      form.find('.personal-only').show()
      form.find('.business-only').hide()
      form.find('input.business-only').attr('required', false)
      form.find('input.personal-only[data-required="true"]').attr('required', true)
    }
  });
});